import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';
import { HttpService } from '../http.service';
// import {_} from 'underscore';
import * as _ from 'underscore';
import { DateTime} from 'luxon';
import { Messages} from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';
declare var google: any;


export interface ILatLng {
  latitude: Number;
  longitude: Number;
}
export interface Location {
  // coordinates: ILatLng,
  area: String;
  contact_name: String;
  mobile: String;
  pincode: String;
  name: String;
  latitude: Number;
  longitude: Number;
  organization: String;
  locality: String;
  city: String;
  landmark?: String;
  access_time: {
    start: '',
    end: ''
  };
}
@Component({
  selector: 'app-favorite-location',
  templateUrl: './favorite-location.component.html',
  styleUrls: ['./favorite-location.component.scss']
})
export class FavoriteLocationComponent implements OnInit {

  start: any;
  end: any;
  marker: ILatLng;
  headerText = '';

  geofences = [];

  LocationData: Location = {
    // coordinates: this.marker,
    latitude: 0,
    longitude: 0,
    area: '',
    contact_name: '',
    mobile: '',
    name: '',
    pincode: '',
    city: '',
    organization: '',
    locality: '',
    // landmark: '',
    access_time: {
      start: '',
      end: ''
    }
  };
  access_time: any = {
    start: '',
    end: ''
  };
  markers = [];
  map: any;
  messages = new Messages();
  constructor(private dialog: MatDialogRef<FavoriteLocationComponent>, private snackbar: SnackbarService, private valid: ValidationService,
              private http: HttpService, @Inject(MAT_DIALOG_DATA) private parentData: any,
              private translation: TranslateService) { }

  ngOnInit() {
    this.headerText = this.parentData.heading || 'Pickup Address';
    this.initMap();
    this.initAutoSuggestions();
    this.LocationData.organization = this.parentData.organisation_id;
  }
  closeDialog() {
    this.dialog.close();
  }


  initMap(lat = 0, lng = 0) {
    let marker: any;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        marker = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        this.map.setCenter(marker);
      });
    }
    this.marker = {
      latitude: lat,
      longitude: lng
    };
    const mapProp = {
      center: new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    };
    this.map = new google.maps.Map(document.getElementById('map'), mapProp);
    // this.placeMarker(center);
    google.maps.event.addListener(this.map, 'click', function(event) {
      // this.placeMarker(event.latLng);
    });
  }
  removeMarkers(markers) {
    markers.forEach(element => {
      element.setMap(null);
    });
  }

  placeMarker(location = this.marker) {
    if (this.markers) {
      this.removeMarkers(this.markers);
    }
    const marker = new google.maps.Marker({
      position: { lat: location.latitude, lng: location.longitude },
      map: this.map,
      draggable: true
    });
    this.markers.push(marker);
    marker.setMap(this.map);
    this.map.setCenter({ lat: location.latitude, lng: location.longitude });
    google.maps.event.addListener(marker, 'dragend', function() {
      // geocodePosition(marker.getPosition());
    });
  }

  plotPolyLine(geofence, strokeColor = '#FF0000') {

    const path = google.maps.geometry.encoding.decodePath(geofence);
    const polyline = new google.maps.Polyline({
      path,
      strokeColor,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
      map: this.map
    });

    polyline.setMap(this.map);
    this.geofences.push(polyline);
    this.map.setZoom(10);
  }
  clearGeofence() {
    if (this.geofences.length) {
      for (const fence of this.geofences) {
        fence.setMap(null);
      }
      this.geofences.length = 0;
    }
  }

  initAutoSuggestions() {

    const input = document.getElementById('placesSearch');
    const options = {

    };

    const autocomplete = new google.maps.places.Autocomplete(input, options);
    const context = this;
    autocomplete.addListener('place_changed', function() {
      const place = autocomplete.getPlace();
      context.marker.latitude = place.geometry.location.lat();
      context.marker.longitude = place.geometry.location.lng();
      context.LocationData.latitude = place.geometry.location.lat();
      context.LocationData.longitude = place.geometry.location.lng();
      // context.LocationData.coordinates = context.marker;
      context.LocationData.pincode = (place.address_components[place.address_components.length - 1].types.includes('postal_code')) ? place.address_components[place.address_components.length - 1].long_name : '';
      context.LocationData.area = place.formatted_address;
      const locality = _.find(place.address_components, (component) => {
        return _.indexOf(component.types, 'locality') > -1;
      });
      const city = _.find(place.address_components, (component) => {
        return _.indexOf(component.types, 'administrative_area_level_2') > -1;
      });
      context.LocationData.locality = (locality) ? locality.long_name : '';
      context.LocationData.city = (city) ? city.long_name : '';

      context.placeMarker();
      if (!place.geometry) {
        return;
      }
    });
  }

  validate(Obj: Location): Boolean {
    let validf = true;
    if (!this.valid.isEmpty(Obj.area) && !this.valid.isEmpty(Obj.latitude) &&
        !this.valid.isEmpty(Obj.longitude) && !this.valid.isEmpty(Obj.name)
        && !this.valid.isEmpty(Obj.contact_name) && !this.valid.isEmpty(Obj.city) && !this.valid.isEmpty(Obj.mobile)) {
          if (!this.valid.isMobile(Obj.mobile)) {
            this.snackbar.openSnackBar(this.translation.instant('FAVORITELOCATION.validMobile'), '', 'err');
            validf = false;
          } else {
            return validf;
          }
        } else {
          this.snackbar.openSnackBar(this.translation.instant('FAVORITELOCATION.fillAll'), '', 'err');
          validf = false;
          return validf;
        }

  }
  setTime(value, flag = true) {
    const temp = DateTime.fromFormat(value, 'hh:mm a').toSeconds();
    const temp2 = DateTime.local().startOf('day').toSeconds();
    if (flag) {
      this.access_time.end = (temp - temp2).toString();
    } else {
      this.access_time.start = (temp - temp2).toString();
    }
  }
  saveLocation() {

    if (this.access_time.start && this.access_time.end) {
      this.LocationData.access_time = this.access_time;
    } else {
      delete this.LocationData.access_time;
    }
    if (this.validate(this.LocationData)) {
      const data = this.LocationData;
      this.http.post('location/create', data).subscribe(
        (data: any) => {
          if (data.statusCode == 200) {
            this.snackbar.openSnackBar(this.messages.FAVORITE_LOCATION.SUCCESS.LOCATION_ADD, '');
            this.dialog.close({ location: data, type: this.headerText });
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
          if (err.error.statusCode == 401) {
            this.valid.logout();
          }
        }
      );
    }


  }
}
